// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"DP9nl","pathItem":"tUAsd","noLinkItem":"sSKKr","viewOnly":"n3hob"};